import { Tab } from 'components/organisms/tabs';
import { AutomatedIndexingTask } from 'features/automatedIndexing/types';
import { MenuItem } from 'types/table';

type TabDetails = {
  [tab in 'NEW_ORDER' | 'TRAINING_READY' | 'ERRORS']: Tab;
};

// Single source of truth for tab values
const TAB_DETAILS: TabDetails = {
  NEW_ORDER: {
    label: 'New Orders',
    value: 'new',
  },
  TRAINING_READY: {
    label: 'Training Ready',
    value: 'trainingReady',
  },
  ERRORS: {
    label: 'Errors',
    value: 'errors',
  },
};

const TABS: Tab[] = [
  { label: TAB_DETAILS.NEW_ORDER.label, value: TAB_DETAILS.NEW_ORDER.value },
  {
    label: TAB_DETAILS.TRAINING_READY.label,
    value: TAB_DETAILS.TRAINING_READY.value,
  },
  { label: TAB_DETAILS.ERRORS.label, value: TAB_DETAILS.ERRORS.value },
];

enum TABLE_MENU_ACCESSOR {
  DELETE_TASK = 'DELETE_TASK',
}

const TABLE_MENU_CONFIG: MenuItem<AutomatedIndexingTask>[] = [
  {
    label: 'Delete',
    isDangerAction: true,
    accessor: TABLE_MENU_ACCESSOR.DELETE_TASK,
    isHidden: (item: AutomatedIndexingTask) => !item._links?.['delete'],
  },
] as const;

export { TABS, TAB_DETAILS, TABLE_MENU_ACCESSOR, TABLE_MENU_CONFIG };
